import { Checkbox } from "primereact/checkbox";

interface REICheckBoxProps {
  id?: string;
  testId?: string;
  checked: boolean;
  onChange: (e: any) => void;
  className?: string;
  label?: string;
  disabled?: boolean;
}

const REICheckBox: React.FC<REICheckBoxProps> = ({ id, testId, checked, onChange, className = "mr-1", label, disabled }) => {
  return (
    <>
      <Checkbox
        inputId={id}
        data-testid={testId ?? id}
        disabled={disabled}
        onChange={onChange}
        checked={checked}
        className={className}
      ></Checkbox>
      {label && <span>{label}</span>}
    </>
  );
};

export default REICheckBox;
